import { SmartCaptcha, SmartCaptchaProps } from '@yandex/smart-captcha';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { setCaptchaToken } from '../../actions/chat/actions';
import { useApplicationContext } from '../../utils/applicationContext';

interface ICaptchaProps {
  chatId?: string;
}

type TJavascriptError = Parameters<NonNullable<SmartCaptchaProps['onJavascriptError']>>[0];

export const Captcha: React.FC<ICaptchaProps> = ({ chatId }) => {
  const { config, logger } = useApplicationContext();

  const dispatch = useDispatch();

  const sitekey = config.get<string>('frontend-chats.YandexCaptchaSiteKey');

  const onCaptchaSuccess = React.useCallback(
    (token?: string) => {
      if (!chatId) {
        return;
      }

      dispatch(setCaptchaToken({ chatId, captchaToken: token }));
    },
    [dispatch, chatId],
  );

  const handleCaptchaJsError = React.useCallback(
    (jsError: TJavascriptError) => {
      logger.error(jsError.message, { domain: 'captcha.jsError', chatId });
    },
    [chatId, logger],
  );

  const handleCaptchaNetworkError = React.useCallback(() => {
    logger.error('Ошибка сети при запросе капчи', { domain: 'captcha.networkError', chatId });
  }, [chatId, logger]);

  const handleCaptchaTokenExpired = React.useCallback(() => {
    logger.warning('Токен капчи стал невалидным', { domain: 'captcha.tokenExpired', chatId });

    onCaptchaSuccess();
  }, [logger, chatId, onCaptchaSuccess]);

  if (!sitekey) {
    return null;
  }

  return (
    <SmartCaptcha
      sitekey={sitekey}
      onSuccess={onCaptchaSuccess}
      onJavascriptError={handleCaptchaJsError}
      onNetworkError={handleCaptchaNetworkError}
      onTokenExpired={handleCaptchaTokenExpired}
    />
  );
};
